import React from 'react';

export default function BgImage() {
  return (
    <svg width={127} height={100} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32.738 73.744a3.11 3.11 0 0 1-2.163 3.831L12.59 82.578 8.263 90.24 1.593 66.26a3.111 3.111 0 0 1 2.164-3.83l20.981-5.837a3.111 3.111 0 0 1 3.831 2.164l4.169 14.986Z"
        stroke="#ADADAD"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.085 66.944a3.265 3.265 0 0 1 6.404-.652c.584 2.097-2.27 4.02-2.27 4.02M18.47 74.483l.012-.003M43.766 14.183a2.275 2.275 0 0 0 1.608 2.785l13.183 3.533 3.217 5.571 4.71-17.576a2.274 2.274 0 0 0-1.609-2.786l-15.38-4.121a2.275 2.275 0 0 0-2.785 1.608l-2.944 10.986Z"
        stroke="#ADADAD"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.599 7.877a2.387 2.387 0 0 1 4.28 1.96c-.41 1.538-2.92 1.694-2.92 1.694M54.203 14.625l.008.002M104.164 87.584a2.09 2.09 0 0 0 1.478 2.56l12.118 3.247 2.957 5.122 4.33-16.157a2.095 2.095 0 0 0-1.479-2.561l-14.137-3.788a2.091 2.091 0 0 0-2.561 1.478l-2.706 10.099Z"
        stroke="#ADADAD"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M113.202 81.787a2.194 2.194 0 0 1 3.934 1.802c-.375 1.414-2.684 1.558-2.684 1.558M113.758 87.99l.007.002"
        stroke="#ADADAD"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
